import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import AppStoreLink from '../../../../../../../components/global/AppStoreLink';
import PlayStoreLink from '../../../../../../../components/global/PlayStoreLink';
import Button from '../../../../../../../components/global/Button';

export const DOWNLOAD_PHOTOS_HELP_OPTIONS = {
  APP_DOWNLOAD: 'APP_DOWNLOAD',
  BROWSER: 'BROWSER',
  EMAIL: 'EMAIL',
};

const propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.oneOf(Object.values(DOWNLOAD_PHOTOS_HELP_OPTIONS)),
  ),
  onViewPhotos: PropTypes.func,
};

const DownloadPhotosHelp = ({ options, onViewPhotos }) => {
  return (
    <div className="download-photos-help-container">
      <h4 className="text-center text-dark">How to download your photos:</h4>
      {options.map((option, index) => {
        switch (option) {
          case DOWNLOAD_PHOTOS_HELP_OPTIONS.APP_DOWNLOAD: {
            return (
              <Fragment key={index}>
                <div className="download-photos-help-option">
                  <p className="download-photos-help-option-label">
                    Option {index + 1}
                  </p>
                  <p className="text-extra-bold text-dark">
                    Download one of the Waldo apps to view, share &amp; download
                    your pics!
                  </p>
                  <div className="native-apps-cta-box-apps my-1">
                    <AppStoreLink />
                    <PlayStoreLink />
                  </div>
                </div>
                {index + 1 !== options.length && (
                  <p className="my-1 text-center download-photos-help-option-label">
                    OR
                  </p>
                )}
              </Fragment>
            );
          }
          case DOWNLOAD_PHOTOS_HELP_OPTIONS.BROWSER: {
            return (
              <Fragment key={index}>
                <div className="download-photos-help-option">
                  <p className="download-photos-help-option-label">
                    Option {index + 1}
                  </p>
                  <p className="text-extra-bold text-dark">
                    Download your pics from your browser now!
                  </p>
                  <Button onClick={onViewPhotos} btnBlock>
                    View my photos
                  </Button>
                </div>
                {index + 1 !== options.length && (
                  <p className="my-1 text-center download-photos-help-option-label">
                    OR
                  </p>
                )}
              </Fragment>
            );
          }
          case DOWNLOAD_PHOTOS_HELP_OPTIONS.EMAIL:
          default: {
            return (
              <Fragment key={index}>
                <div className="download-photos-help-option">
                  <p className="download-photos-help-option-label">
                    Option {index + 1}
                  </p>
                  <p className="text-extra-bold text-dark">
                    Check your email for a link to download your pics later!
                  </p>
                </div>
                {index + 1 !== options.length && (
                  <p className="my-1 text-center download-photos-help-option-label">
                    OR
                  </p>
                )}
              </Fragment>
            );
          }
        }
      })}
    </div>
  );
};

DownloadPhotosHelp.propTypes = propTypes;

export default DownloadPhotosHelp;
